import React from 'react';
import "./skills.css"
const Other = () =>{

    return(
        <div className="skills__content">
        <h3 className="skills__title">Other Skills</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Adobe Premiere Pro</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Unity</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>


                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Swift</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Adobe After Effects</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">C#</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div>
                    <h3 className="skills__name">Flutter</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

            </div>

            
        </div>
    </div>
    )
}


export default Other